import styled, { css } from 'styled-components';
import { withLayout } from '@rsos/components/capstone/base/Layout';
import { breakpoints } from '@rsos/constants';
import { LOCATION_LIST_CONTAINER_WIDTH } from '../../constants/dataComponentsDimensions';

const { BP_LAPTOP, BP_TABLET } = breakpoints;

const MapContainer = withLayout(styled.div`
  display: flex;
  height: 100%;
  position: relative;
  width: ${({ hasLocationsToRender, hasW3wToRender, selectedAlertID }) => {
    if (hasLocationsToRender || hasW3wToRender) {
      return `calc(100% - ${LOCATION_LIST_CONTAINER_WIDTH}px)`;
    } else if (selectedAlertID) {
      return `100%`;
    }
    return `100%`;
  }};
  ${({ isIRP, selectedItem, hasW3wToRender }) =>
    !isIRP && (selectedItem || hasW3wToRender)
      ? css`
          @media (max-width: ${BP_LAPTOP}px) {
            width: 100%;
            height: ${selectedItem
              ? '455px'
              : '100%'}; // set height if there is a selectedItem and the map is on top, otherwise it should fill in the remaining space
          }
          @media (max-width: ${BP_TABLET}px) {
            height: ${selectedItem ? '465px' : '100%'};
          }
        `
      : null}

  ${({ isIRP }) =>
    isIRP &&
    css`
      @media (max-width: ${BP_LAPTOP}px) {
        display: none;
      }
    `}
`);

export default MapContainer;
